function init() {
	if (window.location.hash.length && $(".js-page-faq").length) {
		revealAnchorElement();
		$(window).on("hashchange", revealAnchorElement);
	}
	function revealAnchorElement() {
		const anchorEl = $(`${window.location.hash}-section`);

		if (anchorEl.length) {
			if (anchorEl.hasClass("hidden")) {
				anchorEl.removeClass("hidden");
			}

			const accordionIsExpanded = $(".js-accordion-item:visible").length;
			const segmentBodyEl = anchorEl.find(".js-accordion-button");

			segmentBodyEl.attr("aria-expanded", "true");

			if (accordionIsExpanded) {
				scrollToElement(anchorEl);
			}
		}
	}

	function scrollToElement(el) {
		const headerHeight = 51;

		$("html, body").animate(
			{
				scrollTop: el.offset().top - headerHeight,
			},
			500
		);
	}
}

export { init };
